module.exports = __webpack_public_path__ + "static/alpha_vid-3d30736fb41ef364ebaeac009d6198b9.mp4";